import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import useViewPort from "../../../hook/useViewPort";
import ImageType4 from "../../molecules/image-type-4";
import { currentUser } from "@quintype/bridgekeeper-js";
import { userHistoryApi } from "../../utils/user-history-api";
import "./user-media-history.m.css";
import get from "lodash/get";

const UserMediaHistory = ({ initAccessType, getSubscriptionForUser, cancelSubscription, isATGlobal, member }) => {
    const { viewports } = useViewPort();

    const [userId, setUserId] = useState(null);
    const [yesterdayMedia, setYesterdayMedia] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
      const fetchUserId = async () => {
        try {
          const currentUserResp = await currentUser();
          const userId = currentUserResp?.user?.id || null;
          setUserId(userId);
        } catch (error) {
          console.error("Error fetching user id:", error);
        }
      };
      fetchUserId();
    }, []);

    useEffect(() => {
      const loadData = async () => {
        setLoading(true);

        try {
          const objResult = await userHistoryApi(userId);
          setYesterdayMedia(objResult);
          setError(null);
        } catch (err) {
          console.error("Error fetching user media:", err);
          setError("Historiatietojesi lataamisessa on ongelma.");
        } finally {
          setLoading(false);
        }
      };

      const memberID = get(member, ["id"], "");
      if (memberID) {
        initAccessType(() => {
          getSubscriptionForUser()
            .then((res) => {
              const hasActiveSubs = Array.isArray(res?.subscriptions)
                ? res.subscriptions.some(sub => sub.status === "active")
                : false;

              if (hasActiveSubs) {
                loadData();
              }
            })
            .catch((err) => {
              console.error("Error occurred inside profile page --->", err);
            });
        });
      }
    }, [userId]);

  if (loading) {
    return <div styleName="container">
             <div styleName="history-headline" className={viewports ? viewports : ""}>
              <h2>Jatka katselua</h2>
             </div>
             <div styleName="loading">Ladataan...</div>
          </div>;
  }

  if (error) {
    return <div styleName="container">
             <div styleName="history-headline" className={viewports ? viewports : ""}>
              <h2>Jatka katselua</h2>
             </div>
             <div styleName="error-message">{error}</div>
          </div>;
  }

  return (
    yesterdayMedia.length > 0 && <div styleName="container">
      <div styleName="history-headline" className={viewports ? viewports : ""}>
        <h2>Jatka katselua</h2>
      </div>
      <div styleName="image-grid" className={viewports ? viewports : ""}>
        {yesterdayMedia.map((storyItem, index) => {
          const accessType = storyItem?.story?.access;
          const paywallIcons = accessType === "login" || accessType === "subscription";
          return storyItem?.story ? (
            <Link
              href={storyItem?.story?.slug}
              id={storyItem?.story?.id}
              styleName="image-container"
              className={viewports ? viewports : ""}
              key={storyItem?.story?.id}
            >
              <ImageType4
                story={storyItem?.story}
                aspectRatio={[[16, 9]]}
                />
                <div style={{minHeight: "auto"}} styleName="episode-info">
                    <div styleName="headline-icon">
                      <p>{`${storyItem?.story?.headline}`}</p>
                      {paywallIcons && (
                        <img alt="audio-logo" src="/icons/under-subcription.svg" styleName="custom-img-icon" />
                      )}
                    </div>
                </div>
            </Link>
          ):null;
        })}
      </div>
    </div>
  );
};

export default UserMediaHistory;
